<template>
  <div>

    <b-row>
      <!-- <b-col
          lg="12"
        >
          <div>
            <app-echart-bar
              :option-data="optionBar"
              style="width:auto; height:440px;"
            />
          </div>
        </b-col> -->
      <b-col cols="12">
        <app-echart-bar
          style="width: auto; height: 450px;"
          :option-data="optionBar"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Ripple from 'vue-ripple-directive'
import {
  BRow, BCol,
  // BFormDatepicker, BFormSelect,
} from 'bootstrap-vue'
import axios from '@axios'
// import vSelect from 'vue-select'
import AppEchartBar from './AppEchartBarProgress.vue'

const weatherIcons = {
  // eslint-disable-next-line global-require
  CarParkedShoulder: require('@/assets/images/icons/analyticSciFi/nopark.svg'),
  // eslint-disable-next-line global-require
  CarOverSpeed: require('@/assets/images/icons/analyticSciFi/overspeed.svg'),
  // eslint-disable-next-line global-require
  TruckRightLane: require('@/assets/images/icons/analyticSciFi/truckright.svg'),
  // eslint-disable-next-line global-require
  CarReverse: require('@/assets/images/icons/analyticSciFi/reverse.svg'),
  // eslint-disable-next-line global-require
  SpeedLimit: require('@/assets/images/icons/analyticSciFi/car2.svg'),
  // eslint-disable-next-line global-require
  Construction: require('@/assets/images/icons/analyticSciFi/macro.svg'),
  // eslint-disable-next-line global-require
  RoadBlocking: require('@/assets/images/icons/analyticSciFi/barrier.svg'),
  // eslint-disable-next-line global-require
  BrokenCar: require('@/assets/images/icons/analyticSciFi/carbroke.svg'),
  // eslint-disable-next-line global-require
  Accident: require('@/assets/images/icons/analyticSciFi/caraccident.svg'),
}
const seriesLabel = {
  show: true,
}
export default {
  components: {
    BRow,
    BCol,
    AppEchartBar,
    // BFormDatepicker,
    // BFormSelect,
    // vSelect,
  },
  directives: {
    Ripple,
  },
  // props: {
  //   // ประกาศว่า props 'message' ถูกส่งจากพาเรนต์
  //   date: {
  //     type: Object,
  //     required: true,
  //   },
  // },
  data() {
    return {
      optionBar: {
        title: {
          text: 'Weather Statistics',
        },
        grid: {
          left: 100,
        },
        toolbox: {
          show: true,
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: {
          splitLine: { show: false },
          type: 'value',
          name: '',
          axisLabel: {
            color: 'white',
            formatter: '{value}',
          },
        },
        yAxis: {
          splitLine: { show: false },
          type: 'category',
          inverse: true,
          data: ['CarParkedShoulderCount', 'CarOverSpeedCount', 'TruckRightLaneCount', 'CarReverseCount', 'SpeedLimitCount', 'ConstructionCount', 'RoadBlockingCount', 'BrokenCarCount', 'AccidentCount'],
          axisLabel: {
            fontSize: 14, // ขนาดข้อความ
            color: 'white',
            formatter(value) {
              const labelMap = {
                CarParkedShoulderCount: 'รถจอดไหล่ทาง',
                CarOverSpeedCount: 'รถความเร็วเกิน',
                TruckRightLaneCount: 'รถบรรทุกเลนขวา',
                CarReverseCount: 'รถย้อนเลน',
                SpeedLimitCount: 'จำกัดความเร็ว',
                ConstructionCount: 'งานก่อสร้างทาง',
                RoadBlockingCount: 'การปิดกั้นบนทาง',
                BrokenCarCount: 'รถเสีย',
                AccidentCount: 'รถเกิดอุบัติเหตุ',
              }
              // ใช้ค่าใหม่จากอ็อบเจกต์แมป หากไม่มีการแมปให้ใช้ค่าเดิม
              return `{${value}| }   {value|${labelMap[value] || value}}`
            },
            margin: 20,
            rich: {
              CarParkedShoulderCount: {
                height: 24,
                align: 'center',
                backgroundColor: {
                  image: weatherIcons.CarParkedShoulder,
                },
                color: '#29C6CD',
              },
              CarOverSpeedCount: {
                height: 24,
                align: 'center',
                backgroundColor: {
                  image: weatherIcons.CarOverSpeed,
                },
              },
              TruckRightLaneCount: {
                height: 24,
                align: 'center',
                backgroundColor: {
                  image: weatherIcons.TruckRightLane,
                },
              },
              CarReverseCount: {
                height: 24,
                align: 'center',
                backgroundColor: {
                  image: weatherIcons.CarReverse,
                },
              },
              SpeedLimitCount: {
                height: 24,
                align: 'center',
                backgroundColor: {
                  image: weatherIcons.SpeedLimit,
                },
              },
              ConstructionCount: {
                height: 24,
                align: 'center',
                backgroundColor: {
                  image: weatherIcons.Construction,
                },
              },
              RoadBlockingCount: {
                height: 24,
                align: 'center',
                backgroundColor: {
                  image: weatherIcons.RoadBlocking,
                },
              },
              BrokenCarCount: {
                height: 24,
                align: 'center',
                backgroundColor: {
                  image: weatherIcons.BrokenCar,
                },
              },
              AccidentCount: {
                height: 24,
                align: 'center',
                backgroundColor: {
                  image: weatherIcons.Accident,
                },
              },
            },
          },
        },
        series: [
          {
            name: '',
            type: 'bar',
            label: {
              show: seriesLabel, // แสดงป้ายชื่อ
              position: 'right', // ตำแหน่งป้ายชื่อ (inside, top, left, right, bottom)
              formatter(d) {
                return `${d.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} คัน`
              },
              fontSize: 14, // ขนาดข้อความ
              color: 'white',
            },
            data: [],
            barMaxWidth: '10%',
            barMinWidth: '16px',
            itemStyle: {
              barBorderRadius: [0, 10, 10, 0],
              color(params) {
                const colors = {
                  0: '#FC6359', // สำหรับ CarParkedShoulder
                  1: '#FF90BC', // สำหรับ CarOverSpeed
                  2: '#F2EB00', // สำหรับ TruckRightLane
                  3: '#CC9B6D', // สำหรับ CarReverse
                  4: '#0D6EFD', // สำหรับ SpeedLimit
                  5: '#F8841A', // สำหรับ Construction
                  6: '#094185', // สำหรับ RoadBlocking
                  7: '#29C67B', // สำหรับ BrokenCar
                  8: '#58A8FD', // สำหรับ Accident
                }
                return colors[params.dataIndex] || '#5470c6'
              },
            },
          },
        ],
      },
      datetest: {
        datefrom: '2024-07-26',
        dateto: '2024-07-26',
        sta: '',
      },
      optionDirection: ['ทั้งหมด', 'ขาเข้า', 'ขาออก'],
      optionTime: [{ label: 'รายชั่วโมง', value: 'hourly' }, { label: 'รายวัน', value: 'daily' }, { label: 'รายเดือน', value: 'monthly' }, { label: 'รายปี', value: 'yearly' }],
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
    monthList() {
      const years = []
      // eslint-disable-next-line no-plusplus
      for (let i = this.endMonth; i >= this.startMonth; i--) {
        years.push(i)
      }
      return years
    },
    yearList() {
      const years = []
      // eslint-disable-next-line no-plusplus
      for (let i = this.endYear; i >= this.startYear; i--) {
        years.push(i)
      }
      return years
    },
  },
  mounted() {
    this.interval = setInterval(() => {
      this.getBarChart()
    }, 300000)
    this.getBarChart()
  },
  methods: {
    resetBar() {
      // this.optionBar.xAxisData.splice(0)
      this.optionBar.series[0].data.splice(0)
    },
    // graphLine() {
    //   axios.post('/getLineCountDetail', { wid: this.$route.query.wid })
    //     .then(response => {
    //       this.xAxisData = []
    //       this.xAxisData = response.data
    //       this.xAxisData.forEach(value => {
    //         this.option.series[0].data.push(value.Total_PCU)
    //         this.option.series[0].data.push(value.Total_PCU)
    //         this.option.series[0].data.push(value.Total_PCU)
    //         this.option.series[0].data.push(value.Total_PCU)
    //         this.option.series[0].data.push(value.Total_PCU)
    //         this.option.series[0].data.push(value.Total_PCU)
    //       })
    //       console.log(114477, this.xAxisData)
    //     })
    //     .catch(error => {
    //       console.log(error)
    //     })
    // },
    getBarChart() {
      if (this.$route.query.type !== '0') {
        axios
        // { wid: this.$route.query.wid }
          .post('/getIncidentDetail-G', { wid: this.$route.query.wid })
          .then(response => {
            this.xAxisData = []
            this.resetBar()
            this.xAxisData = response.data
            this.optionBar.series[0].data.push(response.data[0].car_stop)
            this.optionBar.series[0].data.push(response.data[0].over_speed)
            this.optionBar.series[0].data.push(response.data[0].truck_right)
            this.optionBar.series[0].data.push(response.data[0].wrong_way)
            this.optionBar.series[0].data.push(response.data[0].limit_speed)
            this.optionBar.series[0].data.push(response.data[0].road_construction)
            this.optionBar.series[0].data.push(response.data[0].road_block)
            this.optionBar.series[0].data.push(response.data[0].car_breakdown)
            this.optionBar.series[0].data.push(response.data[0].car_accident)
            console.log(555222, response.data)
          })
          .catch(error => {
            console.log(error)
          })
      } else {
        axios
          .post('/getIncidentDetail', { wid: this.$route.query.wid })
          .then(response => {
            this.xAxisData = []
            this.resetBar()
            this.xAxisData = response.data
            this.optionBar.series[0].data.push(response.data[0].car_stop)
            this.optionBar.series[0].data.push(response.data[0].over_speed)
            this.optionBar.series[0].data.push(response.data[0].truck_right)
            this.optionBar.series[0].data.push(response.data[0].wrong_way)
            this.optionBar.series[0].data.push(response.data[0].limit_speed)
            this.optionBar.series[0].data.push(response.data[0].road_construction)
            this.optionBar.series[0].data.push(response.data[0].road_block)
            this.optionBar.series[0].data.push(response.data[0].car_breakdown)
            this.optionBar.series[0].data.push(response.data[0].car_accident)
            console.log(555222, response.data)
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
  },
}
</script>

  <style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';

  .style-chooser .vs__dropdown-toggle {
    border: 0px solid #000000 !important; /* Change #0000FF to the color you'd like on hover */
    background: #131313 !important;
  }
  .style-chooser .vs__dropdown-toggle .vs__search::placeholder {
    color: rgb(255, 255, 255);
    opacity: 1; /* ทำให้สีเห็นชัดเจนขึ้น */
  }
  </style>
